import { TwinManagementSettings } from "@shared/components/twinManagement/types";

export const clientId = "smx-products";

export const prefix = "products.product";

export const roles = {
  admin: "admin",
  user: "user",
};

export const productSettings: TwinManagementSettings = {
  prefix: "products.product.*",
  label: "products",
  baseRoute: "products",
  listViewName: "productsList",
  detailViewName: "productsDetail",
  additionalRoutes: [],
  documents: [],
  tickets: [],
  hideReferenceTypes: [],
  referenceTabs: [],
};
